export const TRANSACTION_STORE_KEY = 'TRANSACTION_STORE_';

export const NEW_TRANSACTION = 'NEW_TRANSACTION';
export const UPDATE_TRANSACTION = 'UPDATE_TRANSACTION';
export const COMPLETE_TRANSACTION = 'COMPLETE_TRANSACTION';
export const REMOVE_TRANSACTION = 'REMOVE_TRANSACTION';
